import { PieChart, Pie, Sector, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import useTranslation from '../../Language/useTranslation';


// 0 - Immer Nicht-Wald
// 1 - Andere Laubbaumarten #D8D79E
// 2 - Buche #FFAA01 
// 3 - Eiche #F9F91F
// 4 - Douglasie #10AF8D
// 5 - Fichte #006FFF
// 6 - Kiefer #8401A9
// 7 - Laerche #71FFCC

const COLORS = ['#D8D79E', '#FFAA01 ', '#F9F91F', '#10AF8D', '#006FFF', '#8401A9', '#71FFCC'];


export default function PieChartTreeType(props: any) {
  const t = useTranslation()
  const baumartenData = props.statisticsBundesland.baumarten
  const data = [
    { name: t.baumartenNames.andereLaubbaumarten, value: baumartenData.andereLaubbaumarten },
    { name: t.baumartenNames.buche, value: baumartenData.buche },
    { name: t.baumartenNames.eiche, value: baumartenData.eiche },
    { name: t.baumartenNames.douglasie, value: baumartenData.douglasie },
    { name: t.baumartenNames.fichte, value: baumartenData.fichte },
    { name: t.baumartenNames.kiefer, value: baumartenData.kiefer },
    { name: t.baumartenNames.laerche, value: baumartenData.laerche },
  ];

  return (
    <div style={{ width: '100%', height: 300 }}>

      <ResponsiveContainer>
        <PieChart width={400} height={400}>
          <Pie data={data} dataKey="value" cx="50%" cy="50%" innerRadius={80} outerRadius={110} fill="#82ca9d" >
            {/* label */}
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip formatter={(value: number, name: string) => value + " %"}

            contentStyle={{ backgroundColor: '#1D1D1D', border: 0, color: '#FFFFFF' }}
            itemStyle={{ color: '#FFFFFF' }}
            cursor={{ fill: '#1D1D1D' }}
          />

          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>

  );

}
